import { h } from 'preact';

const Name = ({ children, className }) => (
  <div class={`font-semibold md:text-lg uppercase tracking-wide flex items-center ${className}`}>
    {children}
  </div>
);

Name.defaultProps = {
  className: ''
};

const Icon = ({ className, ...props }) => (
  <img className={`w-6 md:w-7 mr-2 select-none ${className}`} {...props} />
);

Icon.defaultProps = {
  className: '',
};

const Headline = ({ children, className }) => (
  <h2 class={`mt-2 font-semibold text-4xl md:text-5xl bg-gradient-to-r ${className}`}>
    {children}
  </h2>
);

Headline.defaultProps = {
  className: '',
};

const Description = ({ children, className }) => (
  <p class={`mt-2 md:mt-4 tracking-normal md:tracking-tight font-medium md:text-lg max-w-3xl ${className}`}>
    {children}
  </p>
);

Description.defaultProps = {
  className: '',
};

export default { Name, Icon, Headline, Description };
